import * as React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LoginForm from './LoginForm';
import EnquiryFeedback from './Admin';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginForm />} />
        <Route path="/admin" element={<EnquiryFeedback />} /> {/* Changed from /enquiry-feedback to /admin */}
      </Routes>
    </Router>
  );
}

export default App;